import { useEffect } from 'react';
import RegisterGuidelineModal from 'src/components/AzarOnly/Login/GuidelineModal';
import { ModalType } from 'src/types/Modal';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useCommunityGuidelineModal: OrderedModalHookType = modalPropsPromise => {
  useEffect(() => {
    modalPropsPromise?.resolve([{
      modalProps: {
        key: ModalType.REGISTER_GUIDELINE,
        component: RegisterGuidelineModal
      }
    }]);
  }, [modalPropsPromise]);
};
export default withLoginUserModalPromise(useCommunityGuidelineModal);